/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Material_RequiredInputs */

const vi_care_log_material_required = /** @type {(inputs: Care_Log_Material_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn vật tư cho dòng này`)
};

/**

* @param {Care_Log_Material_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_material_required = /** @type {((inputs?: Care_Log_Material_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Material_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_material_required(inputs)
});